var CryptoJS = require("crypto-js");

const key = "IMELifeInsurance";
var iv = CryptoJS.enc.Utf8.parse("8080808080808080");

export const CryptoJSEncrypt = (plaintext) => {
  const cryptoKey = CryptoJS.enc.Utf8.parse(key);

  const encrypted = CryptoJS.AES.encrypt(plaintext, cryptoKey, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    keySize: 256,
    iv: iv,
    blockSize: 128,
  });

  return encrypted.toString();
};

export const CryptoJSDecrypt = (ciphertext) => {
  try {
    const cryptoKey = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.AES.decrypt(ciphertext, cryptoKey, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      keySize: 256,
      iv: iv,
      blockSize: 128,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    localStorage.removeItem(process.env.REACT_APP_USER_AUTH);
  }
};

var hash = CryptoJS.HmacSHA256("Message", "secret");
var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
